import { convertISO8601ToSS, convertISO8601ToMMSS } from '../../../utils/time';
import { removeUndefinedValues } from '../../../utils/object';

import transcodingStatuses from '../../../constants/transcoding-statuses';
import videoSources from '../../../constants/video-sources';
import freeDealInfo from '../../../constants/free-deal-info';

import getThumbnail from './get-thumbnail';


export default function parseVideo(videoData) {

  const {
    player = {},
    snippet = {},
    contentDetails = {},
  } = videoData;

  let {
    id: externalId,
  } = videoData;

  const { embedHtml } = player;
  const { channelId, title, description, thumbnails } = snippet;
  const { duration, videoId } = contentDetails;

  const width = embedHtml && Number(embedHtml.match(/width="(\d+)/)[1]);
  const height = embedHtml && Number(embedHtml.match(/height="(\d+)/)[1]);

  // >_<
  if (_.isObject(externalId)) {
    externalId = externalId.videoId;
  }
  externalId = externalId || videoId;

  const mediaExternUrl = `//www.youtube.com/embed/${externalId}`;
  const coverUrl = getThumbnail(thumbnails);

  let durationSec;
  let durationStr;
  if (duration) {
    durationSec = convertISO8601ToSS(duration);
    durationStr = convertISO8601ToMMSS(duration);
  }

  return removeUndefinedValues({
    externalId,
    coverUrl,
    width,
    height,
    description,
    title,
    mediaExternUrl,
    mediaStatus: transcodingStatuses.READY,
    channelId,
    dealInfo: freeDealInfo,
    durationSec,
    durationStr,
    videoSource: videoSources.YOUTUBE,
  });

}


export function addChannelData(videoData, channelData) {
  return {
    ...videoData,
    publisher: channelData.title,
    channelData,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/youtube/parsers/video.js